import Service from "../../../Services/index";
import moment from "moment";

const ExampleGift = {
    namespaced: true,
    state: {
        example_gift_list:[],
    },
    mutations: {
        GET_EXAMPLE_GIFT:(state,res)=>{
            state.example_gift_list = res;
        },
    },
    actions: {
        setExampleGift({commit},data){
            return Service.ExampleGift.getExampleGift(data).then(res=>{
                commit("GET_EXAMPLE_GIFT",res);
            });
        },
    }
};

export default ExampleGift;
